<template>
  <div
    v-click-outside="onClickOutside"
    class="select-box"
    :class="{'is-disabled': disabled}"
  >
    <div class="select-box__input">
      <input
        :class="{'focus': isPannelVisible, 'error': isError}"
        type="text"
        :placeholder="currentPlaceholder"
        readonly
        @click="handleClickInput"
      >
      <span
        class="input__suffix"
        @click="handleClickSuffixIcon"
      >
        <i
          class="el-select__caret el-input__icon el-icon-arrow-up"
          :class="{'is-reverse': isPannelVisible}"
        />
      </span>
    </div>
    <span
      class="el-form-item__error input-error"
      v-show="isError && errorMessage"
    >
      {{ errorMessage }}
    </span>
    <div
      v-if="selectedValue.length > 0"
      class="select-box__tags"
    >
      <span>
        <span class="el-tag el-tag--info el-tag--small">
          <span class="el-select__tags-text">
            {{ presentLabel(selectedValue[0]) }}
          </span>
        </span>
        <span
          v-show="selectedValue.length > 1"
          class="el-tag el-tag--info el-tag--small"
        >
          <span class="el-select__tags-text">
            + {{ selectedValue.length - 1 }}
          </span>
        </span>
      </span>
    </div>
    <transition
      name="el-zoom-in-top"
    >
      <div
        v-show="isPannelVisible"
        class="select-box__pannel"
      >
        <ul class="select-box-dropdown__list">
          <ul
            v-for="optionGroup in optionGroups"
            class="select-box-group"
          >
            <li class="select-box-group__title">
              {{ optionGroup.label }}
            </li>
            <li
              v-for="(option, index) in optionGroup.options"
              v-show="!(option.is_removed && !showIsRemoved) "
              :key="index"
              class="select-box-dropdown__item"
              :class="presentOptionClass(option.value)"
              @click="handleClickDropdownItem(option)"
            >
              <span style="float: left;">
                {{ option.label }}
              </span>
            </li>
          </ul>
          <router-link
            class="btn-add-new-class"
            to="/setting/course"
          >
            + 신규수업 개설하기
          </router-link>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash';
import vClickOutside from 'v-click-outside';

export default {
  name: 'ParentCourseSelectBox',
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    placeholder: {
      type: String
    },
    optionGroups: {
      type: Array
    },
    value: {
      required: true
    },
    disabled: {
      default: false
    },
    fixedValue: {
      default() {
        return [];
      }
    },
    showIsRemoved: {
      default: false
    },
    isError: {
      default: false
    },
    errorMessage: {
      default: ''
    }
  },
  data() {
    return {
      isPannelVisible: false,
      selected: [],
      options: []
    };
  },
  computed: {
    selectedValue() {
      return _.union(this.value, this.fixedValue);
    },
    currentPlaceholder() {
      if (this.selectedValue.length > 0) {
        return '';
      }

      return this.placeholder;
    }
  },
  watch: {
    optionGroups: {
      immediate: true,
      handler(optionGroups) {
        this.options = [];

        optionGroups.forEach(group => {
          group.options.forEach(option => this.options.push(option));
        });
      }
    }
  },
  methods: {
    presentLabel(value) {
      let option = this.options.find(option => {
        return option.value === value;
      });

      if (option) {
        return option.label;
      }
    },
    presentOptionClass(value) {
      return {
        selected: this.selectedValue.indexOf(value) > -1
      };
    },
    onClickOutside() {
      this.isPannelVisible = false;
    },
    handleClickInput() {
      if (this.disabled) {
        return;
      }

      this.isPannelVisible = !this.isPannelVisible;
      this.$emit('init');
    },
    handleClickDropdownItem(option) {
      const value = this.value.slice();

      if (this.fixedValue.indexOf(option.value) > -1) {
        return;
      }

      let optionIndex = value.indexOf(option.value);

      if (optionIndex > -1) {
        value.splice(optionIndex, 1);
      } else if (!option.is_removed) {
        value.push(option.value);
      }

      this.$emit('input', value);
      this.$emit('change', value);
    },
    handleClickSuffixIcon() {
      this.isPannelVisible = !this.isPannelVisible;
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/components/select-box';
.select-box-group {
  &:nth-last-child(2) {
    padding: 0;
  }
}

.btn-add-new-class {
  box-sizing: border-box;
  height: 30px;
  line-height: 30px;
  width: 100%;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: -0.6px;
  color: #224ba2 !important;
  background-color: white;
  border: white;
  padding: 0 20px;

  &:hover {
    color: #224ba2 !important;
    text-decoration: underline;
  }
}

.input-error {
  color: #dc1e00;
  font-size: 11px;
  line-height: 17px;
}
</style>
